import memoize from "lodash/memoize";
import { EndpointBindingType, SSOType } from "../../sso-schemes";

const getOptionsLookupForEnum = memoize(<TEnum extends Record<string, unknown>>(sourceEnum: TEnum) => {
  const optionKeys = Object.keys(sourceEnum);
  optionKeys.shift();
  const optionsLookup: Record<string, string> = {};
  optionKeys.forEach((k) => optionsLookup[k] = `${k.toString().charAt(0).toUpperCase()}${k.toString().slice(1)}`);
  return optionsLookup;
});

export const ssoTypeOptionsSource = getOptionsLookupForEnum(SSOType);

export const endpointBindingTypeOptionsSource = getOptionsLookupForEnum(EndpointBindingType);
